import WorkOrderExecutionDetail from '@/models/WorkOrderExecution/WorkOrderExecutionDetail';

export default class WorkOrderExecutionDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderExecutionId  = '';
		this.workOrderExecutionShift = '';
		this.workOrderProcessDetailId  = '';
		this.workOrderProcessDetailPart = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.goodQty = '';
		this.pendingQty = '';
		this.totalQty = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderExecutionId : '0',
			workOrderExecutionShift : '0',
			workOrderProcessDetailId : '0',
			workOrderProcessDetailPart : '0',
			partId : '0',
			partPartNumber : '0',
			goodQty : '0',
			pendingQty : '0',
			totalQty : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}